import AnalyticsProvider from "./src/contexts/analytics/provider";
import AuthProvider from "./src/contexts/auth/provider";
import CartProvider from "./src/contexts/cart/provider";
import LoyaltyProvider from "./src/contexts/loyalty/provider";
import DeliveryEstimateProvider from "./src/contexts/delivery-estimate/provider";
import ErrorNotifierProvider from "./src/contexts/error-notifier/provider";
import { InstantSearchProvider } from "./src/components/instant-search/InstantSearchProvider";
import { LocationProvider } from "@reach/router";
import OneClickCheckoutProvider from "./src/contexts/one-click-checkout/provider";
import { ThemeProvider, vmTheme, wmTheme } from "@vinomofo/components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { isWhiskymofo } from "./src/utils/is-page";

const theme = isWhiskymofo ? wmTheme : vmTheme;

export const wrapRootElement = ({ element }) => {
  return (
    <ErrorNotifierProvider>
      <LocationProvider>
        <AuthProvider>
          <QueryClientProvider client={new QueryClient()}>
            <LoyaltyProvider>
              <OneClickCheckoutProvider>
                <AnalyticsProvider>
                  <CartProvider>
                    <DeliveryEstimateProvider>
                      <ThemeProvider theme={theme}>
                        <InstantSearchProvider>{element}</InstantSearchProvider>
                      </ThemeProvider>
                    </DeliveryEstimateProvider>
                  </CartProvider>
                </AnalyticsProvider>
              </OneClickCheckoutProvider>
            </LoyaltyProvider>
          </QueryClientProvider>
        </AuthProvider>
      </LocationProvider>
    </ErrorNotifierProvider>
  );
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.state?.refinementList) {
    return false;
  }
  return true;
};

let deployBranchMiddlewareAdded = false;
function addDeployBranchMiddleware() {
  if (
    typeof window === "undefined" ||
    !window.analytics ||
    deployBranchMiddlewareAdded
  ) {
    return;
  }
  if (
    typeof window.analytics.addSourceMiddleware !== "function" &&
    typeof window.analytics.addMiddleware !== "function"
  ) {
    return;
  }
  const branch = process.env.GATSBY_DEPLOY_BRANCH;
  const injectDeployBranch = (payload, next) => {
    const type = typeof payload.type === "function" ? payload.type() : payload.obj?.type ?? payload.type;
    if (type === "track" || type === "page") {
      const obj = payload.obj || payload;
      const properties = obj.properties || {};
      properties.deploy_branch = branch;
      obj.properties = properties;
    }
    next(payload);
  };
  if (typeof window.analytics.addSourceMiddleware === "function") {
    window.analytics.addSourceMiddleware(({ payload, next }) => injectDeployBranch(payload, next));
  } else if (typeof window.analytics.addMiddleware === "function") {
    window.analytics.addMiddleware(({ payload, next }) => injectDeployBranch(payload, next));
  } else {
    return;
  }
  deployBranchMiddlewareAdded = true;
}

export const onClientEntry = () => {
  addDeployBranchMiddleware();
};

export const onRouteUpdate = (route) => {
  window.setTimeout(function () {
    addDeployBranchMiddleware();
    if (window.analytics) {
      window.analytics.page(document.title, {
        path: route.location.pathname,
        referrer: route.prevLocation ? route.prevLocation.href : "",
      });
    }
  }, 50);
};
